export const PLACEHOLDER_IMAGE = 'https://assets.thdstatic.com/images/v1/add-product-dark.svg';
